import { render, staticRenderFns } from "./DeliveryPage.vue?vue&type=template&id=637562fa&scoped=true"
import script from "./DeliveryPage.vue?vue&type=script&lang=js"
export * from "./DeliveryPage.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPage.vue?vue&type=style&index=0&id=637562fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637562fa",
  null
  
)

export default component.exports